import { setSliceState } from "../helper"; // Import the utility function

const createModalSlice = (set, get) => ({
  modal: {
    isOpen: false,
    title: "",
    content: null,
    onClose: null,
    onSubmit: null,
    onSubmitText: "",

    openModal: (modalObject) => {
      setSliceState("modal", {
        ...modalObject,
        isOpen: true,
      });
    },
    closeModal: () => {
      // Reset the modal state using the helper function
      setSliceState("modal", {
        isOpen: false,
        title: "",
        content: null,
        onClose: null,
        onSubmit: null,
        onSubmitText: "",
      });
    },
  },
});

export default createModalSlice;
